import React from "react";
import { Container, Row, Form, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import studentsService from "presentation/services/students";
import usersService from "presentation/services/users";

import PageLoadingIndicator from "presentation/components/page-loading-indicator";
import PageAlert from "presentation/components/page-alert";

import StudentUserForm from 'presentation/pages/students/elements/student-user-form';

import { handleChange } from "presentation/utils/functions/generic";

class StudentUserInfo extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      form: {},
      actionLoading: false,
      error: false,
      message: '',
    };
    this.loadData = this.loadData.bind(this);

  }

  async componentDidMount() {
    const { id } = this.props.match.params
    await this.loadData(id);
  }

  loadData = async (id) => {
    await studentsService.findById(id).then(async (result) => {
      var studentInfo = {
        id: result.id,
        registration: result.registration
      }

      if (typeof (result.person) !== 'undefined') {


        studentInfo = {
          ...studentInfo,
          personId: result.person.id,
          userId: result.person.userId,
          name: result.person.name,
          displayName: result.person.displayName
        }
        if (result.person.userId) {
          await usersService.findById(result.person.userId).then((userResult) => {
            studentInfo.email = userResult.email;
            studentInfo.username = userResult.username;
          });
        }

      }
      this.setState({ form: studentInfo, loading: false });
    });
  }

  goTo = (destination) => {
    const { history } = this.props;

    history.push(destination);
  };

  handleSubmit = async () => {

    this.setState({ loading: true, actionLoading: true, error: '' });

    const {
      email,
      newPassword,
      userId
    } = this.state.form;

    if (!email) {
      this.setState({ loading: false, error: true, message: "Por favor, preencha um email válido..." });
    } else {
      if (!userId && !newPassword) {
        this.setState({ loading: false, error: true, message: "Por favor, preencha uma senha..." });
      } else {
        let postData = this.state.form;
        postData.password = postData.newPassword;

        try {
          const response = await studentsService.saveUser(postData);
          if (response.error == true) {
            this.setState({
              loading: false,
              actionLoading: false,
              error: true,
              message: response.message
            });
          } else {

            this.goTo("/alunos");
          }
        } catch (err) {
          this.setState({
            loading: false,
            actionLoading: false,
            error: true,
            message: err.message
          });
        }
      }

    }
  };

  render() {
    let { location } = this.props;
    let { loading, error, message, actionLoading, form } = this.state;
    let { handleSubmit } = this;

    return (
      <div>
        {loading === true && <PageLoadingIndicator loadingText={actionLoading ? "Por favor, aguarde..." : "Carregando informações..."} />}
        {loading === false && error === true && <PageAlert className="m-b-20" message={"Erro"} description={message} type="danger" />}
        {loading === false && (
          <Container>
            <Row>
              <StudentUserForm
                handleChange={handleChange}
                handleSubmit={handleSubmit}
                loading={loading}
                form={form}
                component={this}
              />
            </Row>
          </Container>
        )
        }
      </div>
    );
  };
}

export default StudentUserInfo;
